<script setup lang="ts">
import { cn } from '@/utils/cn'
import type { ComponentOptions } from 'vue'
import { useIdeStore } from '@/stores/ide.store'
import { watch } from 'vue'
import { ref } from 'vue'

const activeTab = ref(1)

interface Tab {
  label: ComponentOptions<any>
}

defineProps<{ tabs: [Tab, Tab] }>()

const ideStore = useIdeStore()

watch(
  () => ideStore.isCodeExecuting,
  (isCodeExecuting) => {
    if (isCodeExecuting) {
      activeTab.value = 1
    }
  }
)

/**
 * @param tab set active tab
 */
const setActiveTab = (tab: number) => {
  activeTab.value = tab
}
</script>

<template>
  <div class="pb-3 lg:pb-0">
    <div class="flex w-fit flex-wrap gap-1 rounded-md p-1">
      <button
        @click="setActiveTab(1)"
        :class="
          cn('text-low relative flex-1 rounded-md px-3 py-1.5', {
            'text-high ': activeTab === 1
          })
        "
      >
        <component :is="tabs[0].label"></component>
      </button>
      <button
        @click="setActiveTab(2)"
        :class="
          cn('text-low relative flex-1 rounded-md px-3 py-1.5', {
            'text-high': activeTab === 2
          })
        "
      >
        <component :is="tabs[1].label"></component>
      </button>
    </div>
    <div v-if="activeTab === 1" class="h-full">
      <slot name="slot1"></slot>
    </div>
    <div v-if="activeTab === 2" class="h-full">
      <slot name="slot2"></slot>
    </div>
  </div>
</template>
